module.exports = __webpack_public_path__ + "static/media/research-data-science-models.89f6dee2.png";